import { memo, type FC } from 'react';
import { ArrowShortRight, PersonDefault } from '@shared/assets';
import { useMobile } from '@shared/hooks';
import { IconButton } from '@shared/ui';
import type { User } from '@src/library/models/users';
import * as st from './styles.module.scss';

interface Props {
  person?: User;
  onNavigate?: () => void;
}

export const Person: FC<Props> = memo(({ person, onNavigate }) => {
  const { isMobile } = useMobile();

  return (
    <section className={st.person}>
      <div className={st.person__content}>
        <div className={st.image}>
          {person?.photo && <img src={person.photo} alt="" />}
          {!person?.photo && <PersonDefault />}
        </div>
        <div className={st.text}>
          {!isMobile ? (
            <div className={st.text__title}>
              {`${person?.last_name}  ${person?.first_name} ${person?.middle_name ?? ''}`}
            </div>
          ) : (
            <>
              <div className={st.text__title}>{`${person?.last_name}`}</div>
              <div className={st.text__title}>{`${person?.first_name}`}</div>
            </>
          )}
        </div>
      </div>
      <div className={st.person__navigate} onClick={onNavigate}>
        <IconButton variant="dark">
          <ArrowShortRight />
        </IconButton>
      </div>
    </section>
  );
});
